import { render, staticRenderFns } from "./editClinic.vue?vue&type=template&id=3a88253a&"
import script from "./editClinic.vue?vue&type=script&lang=js&"
export * from "./editClinic.vue?vue&type=script&lang=js&"
import style0 from "./editClinic.vue?vue&type=style&index=0&id=3a88253a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports